import { api } from './client';
import type { Role } from '@/domain/roles';

export interface Me {
  /** name 是这个人在**当前组织**里的显示名，由管理员设置，本人改不了。 */
  user: { id: string; email: string; name: string };
  organization: { id: string; name: string };
  /** 该成员的全部角色，服务端已去重并按 admin → finance → member 排好序。 */
  roles: Role[];
}

export async function getMe() {
  const { data } = await api.post<Me>('/me/get', {});
  return data;
}

/**
 * 🔴 这里没有改姓名 / 改邮箱的接口，服务端也没有。姓名是组织内的显示名，
 * 只有管理员能设置（api/members.ts 的 updateMemberName）。
 */
